/* eslint-disable max-len */
const React = require('react');

const OverViewOnlinePayments = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <g fill="none" fillRule="evenodd">
      <g stroke="#009EE3" strokeWidth="1.25">
        <g>
          <g transform="translate(-362 -1209) translate(362 1209) translate(.625 13.75)">
            <g>
              <rect width="33.125" height="21.25" fill="#FFF" rx=".909" />
              <path strokeLinecap="square" d="M.625 4.688L31.875 4.688M.625 8.75L31.875 8.75M3.75 16.563L7.5 16.563M10 16.563L13.75 16.563" />
            </g>
            <rect width="21.25" height="10" x="17.5" y="15" fill="#FFF" rx=".909" />
            <path strokeLinecap="square" d="M20 19.688L35.375 19.688" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

module.exports = OverViewOnlinePayments;
